import {component} from '../form/Constant'
import {parameterValue} from '../parameter/ParameterConstants'
import {convertKeyToLabel} from '../table-utils/TableUtils'

export function getObsColors() {
    return localStorage.getItem('obsColors')
        ? JSON.parse(localStorage.getItem('obsColors'))
        : {lv1: 'white', lv2: '#fef3b3', lv3: '#fcce92', lv4: '#f39c81'}
}

export function setObsColors(obsColors) {
    if (obsColors && Object.keys(obsColors).length > 0) {
        localStorage.setItem('obsColors', JSON.stringify(obsColors))
    } else {
        localStorage.setItem(
            'obsColors',
            JSON.stringify({
                lv1: 'white',
                lv2: '#fef3b3',
                lv3: '#fcce92',
                lv4: '#f39c81',
            }),
        )
    }
}

export function setLineChartDrawn(value) {
    localStorage.setItem('lineChartDrawn', JSON.stringify(value))
}

export function getLineChartDrawn() {
    return localStorage.getItem('lineChartDrawn')
        ? JSON.parse(localStorage.getItem('lineChartDrawn'))
        : false
}

export function removeObsColors() {
    localStorage.removeItem('obsColors')
}

export function setShowAllColors(isShown) {
    localStorage.setItem('showAllObsColors', JSON.stringify(isShown))
}

export function getShowAllColors() {
    return localStorage.getItem('showAllObsColors')
        ? JSON.parse(localStorage.getItem('showAllObsColors'))
        : ''
}

export const holderValue = ''
export const dataCols = 24
export const displayCols = 24

export const colHeaderBackground = 'darkcyan'
export const colHeaderColor = 'white'

export const colors = getObsColors()

export const operators = {
    greaterThan: 'greaterThan',
    greaterOrEqualTo: 'greaterOrEqualTo',
    lessThan: 'lessThan',
    lessOrEqualTo: 'lessOrEqualTo',
    equal: 'equal',
    between: 'between',
}

export const levels = [
    {label: 'None', value: 25},
    {label: 'Mild', value: 50},
    {label: 'Moderate', value: 75},
    {label: 'Severe', value: 100},
]

export const deviceTypes = {
    computer: {label: 'Computer', value: 'computer'},
    mobile: {label: 'Mobile', value: 'mobile'},
    watch: {label: 'Watch', value: 'watch'},
}
export const observationKeys = {
    // Patient Info Keys
    ratingScale: 'ratingScale',
    patientName: 'patientName',
    hospitalNumber: 'hospitalNumber',
    hospitalName: 'hospitalName',
    age: 'age',
    arrivalDate: 'arrivalDate',

    // Obs Data Keys
    year: 'year',
    date: 'date',
    time: 'time',
    createdAt: 'createAt',
    levelOfConsciousness: 'levelOfConsciousness',
    confusion: 'confusion',
    respiration: 'respiration',
    heartRate: 'heartRate',
    oxygen: 'oxygen',
    systolic: 'systolic',
    diastolic: 'diastolic',
    bloodPressureLimb: 'bloodPressureLimb',
    bloodPressurePosition: 'bloodPressurePosition',
    temperature: 'temperature',
    tas: 'tas',
    news: 'news',
    comment: 'comment',
    rhythm: 'rhythm',
    bloodPressure: 'bloodPressure',
    painScore: 'painScore',
    bloodGlucoseLevel: 'bloodGlucoseLevel',
    device: 'device',
    initials: 'initials',
    fall: 'fall',
    sleep: 'sleep',
    steps: 'steps',
    seizure: 'seizure',
    anySupplementaryOxygen: 'anySupplementaryOxygen',
    litres: 'litres',
}

export const headerData = [
    {
        key: observationKeys.ratingScale,
        data: [colors.lv1, colors.lv2, colors.lv3, colors.lv4],
    },
]

export const respirationDataRange = [
    {
        value: 25,
        operator: operators.greaterOrEqualTo,
    },
    {
        start: 21,
        end: 24,
        operator: operators.between,
    },
    {
        start: 18,
        end: 20,
        operator: operators.between,
    },
    {
        start: 15,
        end: 17,
        operator: operators.between,
    },
    {
        start: 12,
        end: 14,
        operator: operators.between,
    },
    {
        start: 9,
        end: 11,
        operator: operators.between,
    },
    {
        value: 8,
        operator: operators.lessOrEqualTo,
    },
]

export const spO2DataRange = [
    {
        value: 96,
        operator: operators.greaterOrEqualTo,
    },
    {
        start: 94,
        end: 95,
        operator: operators.between,
    },
    {
        start: 92,
        end: 93,
        operator: operators.between,
    },
    {
        value: 91,
        operator: operators.lessOrEqualTo,
    },
]

export const bloodPressureDataRange = [
    {
        value: 220,
        operator: operators.greaterOrEqualTo,
    },
    {
        start: 201,
        end: 219,
        operator: operators.between,
    },
    {
        start: 181,
        end: 200,
        operator: operators.between,
    },
    {
        start: 161,
        end: 180,
        operator: operators.between,
    },
    {
        start: 141,
        end: 160,
        operator: operators.between,
    },
    {
        start: 121,
        end: 140,
        operator: operators.between,
    },
    {
        start: 111,
        end: 120,
        operator: operators.between,
    },
    {
        start: 101,
        end: 110,
        operator: operators.between,
    },
    {
        start: 91,
        end: 100,
        operator: operators.between,
    },
    {
        start: 81,
        end: 90,
        operator: operators.between,
    },
    {
        start: 71,
        end: 80,
        operator: operators.between,
    },
    {
        start: 61,
        end: 70,
        operator: operators.between,
    },
    {
        start: 51,
        end: 60,
        operator: operators.between,
    },
    {
        value: 50,
        operator: operators.lessOrEqualTo,
    },
]

export const pulseDataRange = [
    {
        value: 131,
        operator: operators.greaterOrEqualTo,
    },
    {
        start: 121,
        end: 130,
        operator: operators.between,
    },
    {
        start: 111,
        end: 120,
        operator: operators.between,
    },
    {
        start: 101,
        end: 110,
        operator: operators.between,
    },
    {
        start: 91,
        end: 100,
        operator: operators.between,
    },
    {
        start: 81,
        end: 90,
        operator: operators.between,
    },
    {
        start: 71,
        end: 80,
        operator: operators.between,
    },
    {
        start: 61,
        end: 70,
        operator: operators.between,
    },
    {
        start: 51,
        end: 60,
        operator: operators.between,
    },
    {
        start: 41,
        end: 50,
        operator: operators.between,
    },
    {
        start: 31,
        end: 40,
        operator: operators.between,
    },
    {
        value: 30,
        operator: operators.lessOrEqualTo,
    },
]

export const temperatureDataRange = [
    {
        value: 39.1,
        operator: operators.greaterOrEqualTo,
    },
    {
        start: 38.1,
        end: 39,
        operator: operators.between,
    },
    {
        start: 37.1,
        end: 38,
        operator: operators.between,
    },
    {
        start: 36.1,
        end: 37,
        operator: operators.between,
    },
    {
        start: 35.1,
        end: 36,
        operator: operators.between,
    },
    {
        value: 35,
        operator: operators.lessOrEqualTo,
    },
]
export const systolicDataRange = [
    {
        value: 39.1,
        operator: operators.greaterOrEqualTo,
    },
    {
        start: 38.1,
        end: 39,
        operator: operators.between,
    },
    {
        start: 37.1,
        end: 38,
        operator: operators.between,
    },
    {
        start: 36.1,
        end: 37,
        operator: operators.between,
    },
    {
        start: 35.1,
        end: 36,
        operator: operators.between,
    },
    {
        value: 35,
        operator: operators.lessOrEqualTo,
    },
]

export const pulseColorData = [
    colors.lv4,
    colors.lv3,
    colors.lv3,
    colors.lv2,
    colors.lv2,
    colors.lv1,
    colors.lv1,
    colors.lv1,
    colors.lv1,
    colors.lv2,
    colors.lv4,
    colors.lv4,
]
export const respirationColorData = [
    colors.lv4,
    colors.lv3,
    colors.lv1,
    colors.lv1,
    colors.lv1,
    colors.lv2,
    colors.lv4,
]
export const bloodPressureColorData = [
    colors.lv4,
    colors.lv1,
    colors.lv1,
    colors.lv1,
    colors.lv1,
    colors.lv1,
    colors.lv1,
    colors.lv2,
    colors.lv3,
    colors.lv4,
    colors.lv4,
    colors.lv4,
    colors.lv4,
    colors.lv4,
]
export const tempColorData = [
    colors.lv3,
    colors.lv2,
    colors.lv1,
    colors.lv1,
    colors.lv2,
    colors.lv4,
]
export const oxiColorData = [colors.lv1, colors.lv2, colors.lv3, colors.lv4]
export const systolicColorData = []
export const obsColWrapperData = [
    {
        key: observationKeys.year,
        label: 'Year',
        colNumber: 1,
        sticky: true,
    },
    {
        key: observationKeys.date,
        label: 'Date',
        colNumber: 1,
        sticky: true,
    },
    {
        key: observationKeys.time,
        label: 'Time',
        colNumber: 1,
        sticky: true,
    },
    {
        key: observationKeys.respiration,
        label: 'Respirations',
        colNumber: 2,
        extraColData: ['≥25', '21-24', '18-20', '15-17', '12-14', '9-11', '≤8'],
        colors: respirationColorData,
        dataRange: respirationDataRange,
    },
    {
        key: observationKeys.oxygen,
        label: 'Sp02 Scale 1',
        colNumber: 2,
        extraColData: ['≥96', '94-95', '92-93', '≤91'],
        colors: oxiColorData,
        dataRange: spO2DataRange,
    },
    {
        key: observationKeys.bloodPressure,
        label: 'Blood Pressure',
        colNumber: 2,
        extraColData: [
            '≥220',
            '201-219',
            '181-200',
            '161-180',
            '141-160',
            '121-140',
            '111-120',
            '101-110',
            '91-100',
            '81-90',
            '71-80',
            '61-70',
            '51-60',
            '≤50',
        ],
        colors: bloodPressureColorData,
        dataRange: bloodPressureDataRange,
    },
    {
        key: observationKeys.heartRate,
        label: 'Heart Rate',
        colNumber: 2,
        extraColData: [
            '≥131',
            '121-130',
            '111-120',
            '101-110',
            '91-100',
            '81-90',
            '71-80',
            '61-70',
            '51-60',
            '41-50',
            '31-40',
            '≤30',
        ],
        colors: pulseColorData,
        dataRange: pulseDataRange,
    },
    {
        key: observationKeys.temperature,
        label: 'Temperature',
        colNumber: 2,
        extraColData: [
            '≥39.1°',
            '38.1°-39.0°',
            '37.1°-38.0°',
            '36.1°-37.0°',
            '35.1°-36.0°',
            '≤35.0°',
        ],
        colors: tempColorData,
        dataRange: temperatureDataRange,
    },
    {
        key: observationKeys.levelOfConsciousness,
        label: 'LOC',
        colNumber: 2,
        extraColData: ['Alert', 'C/V/P/U'],
        colors: [colors.lv1, colors.lv4],
    },
    {
        key: observationKeys.news,
        label: 'NEWS2',
        colNumber: 1,
    },
    {
        key: observationKeys.anySupplementaryOxygen,
        label: convertKeyToLabel(observationKeys.anySupplementaryOxygen),
        colNumber: 1,
    },
    {
        key: observationKeys.litres,
        label: 'Litres',
        colNumber: 1,
    },
    {
        key: observationKeys.painScore,
        label: 'Pain Score',
        colNumber: 1,
    },
    {
        key: observationKeys.bloodGlucoseLevel,
        label: 'Blood Glucose Level',
        colNumber: 1,
    },
    {
        key: observationKeys.comment,
        label: 'Comment',
        colNumber: 1,
    },
    // {
    //     key: observationKeys.rhythm,
    //     label: 'Rhythm',
    //     colNumber: 1,
    // },
    {
        key: observationKeys.device,
        label: 'Device',
        colNumber: 1,
    },
    {
        key: observationKeys.initials,
        label: 'Initials',
        colNumber: 1,
    },
]

// OBS FORM DATA

export const consciousnessOptions = [
    {label: 'Alert (A)', value: 'alert', shorten: 'A'},
    {label: 'Voice (V)', value: 'voice', shorten: 'V'},
    {label: 'Pain (P)', value: 'pain', shorten: 'P'},
    {label: 'Unresponsive (UR)', value: 'unresponsive', shorten: 'UR'},
    {label: 'Confusion(CF)', value: 'confusion', shorten: 'CF'},
    // {label: 'Verbal (VB)', value: 'verbal', shorten: 'VB'},
    // {label: 'Drowsiness (DS)', value: 'drowsiness', shorten: 'DS'},
    // {label: 'Lethargy (LT)', value: 'lethargy', shorten: 'LT'},
    // {label: 'Coma (CM)', value: 'coma', shorten: 'CM'},
]
export const consciousnessOptionsPatientPage = [
    {label: 'Alert (A)', value: 'alert', shorten: 'A'},
    {label: 'Unresponsive (UR)', value: 'unresponsive', shorten: 'UR'},
    {label: 'Confusion(CF)', value: 'confusion', shorten: 'CF'},
    // {label: 'Verbal (VB)', value: 'verbal', shorten: 'VB'},
    // {label: 'Drowsiness (DS)', value: 'drowsiness', shorten: 'DS'},
    // {label: 'Lethargy (LT)', value: 'lethargy', shorten: 'LT'},
    // {label: 'Coma (CM)', value: 'coma', shorten: 'CM'},
]
export const anySupplementaryOxygenOptions = [
    {label: 'Air', value: 'air', shorten: 'A'},
    {label: 'Nasal (N)', value: 'nasal', shorten: 'N'},
    {label: 'Simple Mask (SM)', value: 'simpleMask', shorten: 'SM'},
    // {label: 'Unresponsive (UR)', value: 'unresponsive', shorten: 'UR'},
    // {label: 'Confusion(CF)', value: 'confusion', shorten: 'CF'},
    // {label: 'Verbal (VB)', value: 'verbal', shorten: 'VB'},
    // {label: 'Drowsiness (DS)', value: 'drowsiness', shorten: 'DS'},
    // {label: 'Lethargy (LT)', value: 'lethargy', shorten: 'LT'},
    // {label: 'Coma (CM)', value: 'coma', shorten: 'CM'},
]
export const confusionOptions = [
    {label: 'Yes', value: true},
    {label: 'No', value: false},
]

export const bloodPressureLimbOptions = [
    {label: 'Left Arm (LA)', value: 'leftArm', shorten: 'LA'},
    {label: 'Right Arm (RA)', value: 'rightArm', shorten: 'RA'},
    {label: 'Left Leg (LL)', value: 'leftLeg', shorten: 'LL'},
    {label: 'Right Leg (RL)', value: 'rightLeg', shorten: 'RL'},
    {label: 'Other', value: 'other', shorten: 'O'},
]
export const bloodPressurePositionOptions = [
    {label: 'Lying (Ly)', value: 'lying', shorten: 'Ly'},
    {label: 'Sitting (Si)', value: 'sitting', shorten: 'Si'},
    {label: 'Standing (St)', value: 'standing', shorten: 'St'},
]
export const painOptions = [
    {label: 1, value: 1},
    {label: 2, value: 2},
    {label: 3, value: 3},
    {label: 4, value: 4},
    {label: 5, value: 5},
    {label: 6, value: 6},
    {label: 7, value: 7},
    {label: 8, value: 8},
    {label: 9, value: 9},
    {label: 10, value: 10},
]

export const rhythmOptions = [
    {label: 'Regular', value: 'regular', shorten: 'RE'},
    {label: 'Irregular', value: 'irregular', shorten: 'IR'},
]

export const classNameTypes = {
    col12: 'col-12',
    col6: 'col-6',
    col2: 'col-2',
    col3: 'col-3',
    col9: 'col-9',
    col4: 'col-4',
    col8: 'col-8',
    col5: 'col-5',
    col7: 'col-7',
}

export const observationListForm = [
    {
        key: '',
        description: '',
        children: [
            {
                key: observationKeys.levelOfConsciousness,
                className: `md:${classNameTypes.col8} col-12 `,
                component: component.selectButton,
                options: consciousnessOptions,
                defaultValue: 'alert',
            },
            {
                key: observationKeys.confusion,
                className: `md:${classNameTypes.col4} col-12`,
                component: component.selectButton,
                options: confusionOptions,
            },
            {
                key: observationKeys.heartRate,
                className: classNameTypes.col6,
                component: component.slider,
                min: 0,
                max: 220,
                placeholder: 20,
                step: '',
                shorten: parameterValue.heartRate,
                dataRange: pulseDataRange,
                colors: pulseColorData,
            },
            {
                key: observationKeys.respiration,
                className: `md:${classNameTypes.col6} col-12`,
                component: component.slider,
                placeholder: 0,
                min: 0,
                max: 50,
                step: '',
                shorten: parameterValue.heartRate,
                dataRange: respirationDataRange,
                colors: respirationColorData,
            },
            {
                key: observationKeys.oxygen,
                className: classNameTypes.col12,
                component: component.slider,
                placeholder: 50,
                min: 50,
                max: 100,
                step: '',
                shorten: parameterValue.oxygen,
                dataRange: spO2DataRange,
                colors: oxiColorData,
            },
            {
                key: observationKeys.anySupplementaryOxygen,
                className: `md:${classNameTypes.col6} col-12`,
                component: component.selectButton,
                options: anySupplementaryOxygenOptions,
                dataRange: [],
                shorten: 'Litres/%',
            },
            {
                key: observationKeys.litres,
                className: `md:${classNameTypes.col6} col-12`,
                component: component.slider,
                placeholder: 0,
                min: 0,
                max: 15,
                step: 1,
                // colors: tempColorData,
                // dataRange: temperatureDataRange,
            },
            {
                key: observationKeys.temperature,
                className: classNameTypes.col12,
                component: component.slider,
                placeholder: 27,
                min: 10,
                max: 43,
                step: 0.1,
                shorten: parameterValue.temperature,
                colors: tempColorData,
                dataRange: temperatureDataRange,
            },
            {
                key: observationKeys.bloodPressureLimb,
                className: `md:${classNameTypes.col6} col-12`,
                component: component.selectButton,
                options: bloodPressureLimbOptions,
            },
            {
                key: observationKeys.bloodPressurePosition,
                className: `md:${classNameTypes.col6} col-12`,
                component: component.selectButton,
                options: bloodPressurePositionOptions,
            },
            {
                key: observationKeys.systolic,
                className: `md:${classNameTypes.col6} col-12`,
                component: component.slider,
                placeholder: 40,
                min: 20,
                max: 250,
                step: '',
                shorten: parameterValue.systolic,
                dataRange: bloodPressureDataRange,
                colors: bloodPressureColorData,
            },
            {
                key: observationKeys.diastolic,
                className: `md:${classNameTypes.col6} col-12`,
                component: component.slider,
                placeholder: 30,
                min: 0,
                max: 140,
                step: '',
                shorten: parameterValue.systolic,
            },
            {
                key: observationKeys.painScore,
                className: classNameTypes.col12,
                component: component.selectButton,
                options: painOptions,
            },
            {
                key: observationKeys.bloodGlucoseLevel,
                className: classNameTypes.col12,
                component: component.slider,
                placeholder: 0,
                min: 0,
                max: 30,
                step: '',
                shorten: parameterValue.glucose,
            },
            {
                key: observationKeys.comment,
                className: `${classNameTypes.col12}`,
                component: component.inputTextArea,
                placeholder: 'Input your comment here...',
                isObsForm: true,
                isUseAI: true,
            },
        ],
    },
]

export const shortenValueKeys = [
    observationKeys.consciousness,
    observationKeys.painOnMovement,
    observationKeys.painAtRest,
    observationKeys.rhythm,
    observationKeys.comment,
]
